import React from 'react';

interface MenuCloseIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const MenuCloseIcon: React.FC<MenuCloseIconProps> = ({
  width = 32,
  height = 32,
  color = 'currentColor',
  className,
  style,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    aria-hidden={!title}
    aria-label={title}
  >
    {title && <title>{title}</title>}
    <path
      d="M0.435938 2.56563C-0.145312 1.97813 -0.145312 1.02813 0.435938 0.440625C1.01719 -0.146875 1.97344 -0.140625 2.56094 0.440625L15.9984 13.8781L29.4359 0.440625C30.0234 -0.146875 30.9734 -0.146875 31.5547 0.440625C32.1359 1.02813 32.1422 1.97813 31.5547 2.55938L18.1172 15.9969L31.5547 29.4344C32.1422 30.0219 32.1422 30.9719 31.5547 31.5531C30.9672 32.1344 30.0172 32.1406 29.4359 31.5531L15.9984 18.1156L2.56094 31.5531C1.97344 32.1406 1.02344 32.1406 0.442187 31.5531C-0.139063 30.9656 -0.145312 30.0156 0.442187 29.4344L13.8797 15.9969L0.442187 2.55938L0.435938 2.56563Z"
      fill={color}
    />
  </svg>
);

export default MenuCloseIcon;
